<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="9">
        <b-form onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('batch_label_search') || '交货批次号/批次识别单号搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: { keyword: '' },
    }
  },
  created() {
    this.query()
  },
  methods: {
    query() {
      this.$emit('query', this.form)
    },
  },
}
</script>
